import { createSlice } from '@reduxjs/toolkit'

const miscSlice = createSlice({
  name: 'misc',
  // Filled by the root on boot; v3BaseQuery reads the ids, CSRF token and TMS URL + token from it.
  initialState: { data: { groupId: null, roundId: null } },
  reducers: {
    setMiscData: (state, action) => {
      state.data = { ...state.data, ...action.payload }
    },
  },
})

export const { setMiscData } = miscSlice.actions
export const miscReducer = miscSlice.reducer
